var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var EntitiesCollection = require('../../collections/entities-collection');
var DocumentsCollection = require('../../collections/documents-collection');
var DocumentModel = require('../../models/document-model');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');
var Dicts = require('../../data/dicts');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');
var DocumentsStatisticsView = require('../statistics/documents-statistics-view.js');
var DocumentsStatisticsAggregateView = require('../statistics/documents-statistics-aggregate-view.js');

var SetInitialViewModalView = require("../persons/set-initial-view");

var utils = new CommonUtils();
var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var moment = require('moment');

var DocumentItem = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/documents/document-item.html'),

    ui: {
        previewDoc: '.preview-doc',

        sendingMethods: '.sending-methods',
        customSendingMethods: '.custom-sending-methods',
    },

    events: {
        "click .create-request": "createRequest",
        "click input[type=checkbox]": 'documentSelected',
        "click @ui.previewDoc": 'viewDocument',

        "click @ui.sendingMethods": "showSendingMethods",
        "click @ui.customSendingMethods": "showCustomSendingMethods",
    },

    templateContext: function () {
        var that = this;
        var createdTime = that.model.get('object').createdTime;
        var dueTime = that.model.get('object').dueDate;
        var signedTime = that.model.get('object').signedTime;
        var object = that.model.get('object');
        var relations = that.model.get('relations') || [];
        var relation = _.find(relations, function (item) {
            return item.parentId == that.model.get('id')
                && item.systemRelationType == 'DOCUMENT_PATIENT'
                && item.child.id == object.patientId;
        });
        var orgRelation = _.find(relations, function (item) {
            return item.child.id == object.organizationId
                && item.systemRelationType == 'DOCUMENT_ORGANIZATION'
        });

        var createdByObj;
        if (orgRelation) {
            createdByObj = {name: orgRelation.child.name, url: '/#organization/' + orgRelation.child.id}
        } else if (that.model.get('createdBy')) {
            createdByObj = {name: that.model.get('createdBy').name, url: '/#person/' + that.model.get('createdBy').id}
        }

        return {
            fmCreatedTime: utils.longToDateTimeFormatted(createdTime, "MM/DD/YYYY"),
            fmDueTime: dueTime === 0 ? '' : utils.longToDateTimeFormatted(dueTime, "MM/DD/YYYY"),
            fmSignedTime: signedTime === 0 ? '' : utils.longToDateTimeFormatted(signedTime, "MM/DD/YYYY"),
            patient: relation && relation.child && relation.child.object ? {
                id: relation.child.id,
                name: utils.formatPerson(relation.child.object)
            } : undefined,
            accessSignAction: this.getOption('accessSignAction'),
            createdByObj: createdByObj,
            status: utils.getDocumentStatus(object.status),
            intention: utils.getIntention(object.intention),
            preferredSendingMethods: function () {
                var reviewers = [];
                object.reviewers.forEach(function (rvw) {
                    if (!_.isEmpty(rvw.personId))
                        reviewers.push(rvw.personId);
                    if (!_.isEmpty(rvw.organizationId))
                        reviewers.push(rvw.organizationId);
                });

                var preferredContactsTypes = [];
                relations.forEach(function (relation) {
                    if (relation.child && _.contains(reviewers, relation.child.id)
                        && relation.child.object && relation.child.object.contacts) {
                        _.uniq(relation.child.object.contacts.filter(function (contact) {
                            return contact.preferred === true;
                        }).map(function (contact) {
                            return contact.type;
                        })).forEach(function (contactType) {
                            preferredContactsTypes.push(contactType);
                        });
                    }
                });

                return _.uniq(preferredContactsTypes).sort();
            },
            color: that.downloadColor(),
            byAdmin: that.getOption('byAdmin'),
            deliveryConf: that.getDeliveryConf(),
            relations: relations,
            reviewersNames: function () {
                if (that.revieweresNames == undefined) {
                    that.revieweresNames = that.getRevieweresNames();
                }
                return that.revieweresNames;
            },
            showSendingMethods: that.getOption('showSendingMethods'),
            toUpper: function (val, isPersonName) {
                return val ? val.toUpperCase() : "";
            },
            barCode: object.externalIds
                .filter(function (id) {
                    return id.startsWith(Constants.barCodePrefix);
                }).map(function (id) {
                    return id.replace(Constants.barCodePrefix, "");
                })
                .join(", ") || '-',
            rnsBarCode: object.barcode || '',
            hasCustomContacts: that.hasCustomContacts()
        }
    },

    initialize: function () {
        this.contactsContent = null;
        if (_.isUndefined(this.model.get("selected")))
            this.model.set("selected", false);
    },

    onRender: function () {

        /*if (this.hasCustomContacts()) {
            this.ui.customSendingMethods.popover();
            this.ui.customSendingMethods.on('show.bs.popover', function () {
                var thisPopover = $(this);
                console.log("shown.bs.popover");
            });
        } else {
            this.ui.sendingMethods.popover();
            this.ui.sendingMethods.on('show.bs.popover', function () {
                var thisPopover = $(this);
                thisPopover.data("content", "Loading...");
                this.ui.sendingMethods.data("content", "Loading...");
            });
        }*/

    },

    hasCustomContacts: function () {
        return this.getActualPreferredDocumentContacts().length > 0;
    },

    getActualPreferredDocumentContacts: function () {
        var that = this;
        var now = new Date().getTime();
        return that.model.get('object').contacts.filter(function (contact) {
            return that.actualContactPredicate(contact, now);
        });
    },

    actualContactPredicate: function (contact, now) {
        return contact.preferred && (contact.from == 0 || contact.from <= now) && (contact.to == 0 || contact.to >= now);
    },

    showSendingMethods: function (e) {
        var self = $(e.target);
        var that = this;

        if (!that.contactsContent) {
            console.log('init');
            self.popover({
                html: true,
                content: "<b>Loading...</b>"
            });
            self.popover('show');

            var popoverAsyncRender = function (contactsContent) {
                that.contactsContent = contactsContent;
                self.attr("data-content", that.contactsContent);
                self.popover({
                    html: true,
                    //content: contactsContent
                });
                self.popover('show');
            }

            that.reviewersContactsFetch(popoverAsyncRender);

        } else {
            self.attr("data-content", that.contactsContent);
            self.popover({
                html: true,
                //content: that.contactsContent
            });
            self.popover('show');
        }

        setTimeout(function () {
            self.popover('hide');
        }, 5000);
    },

    showCustomSendingMethods: function (e) {
        var self = $(e.target);

        if (!this.contactsContent) {
            var contacts = this.getActualPreferredDocumentContacts();
            this.contactsContent = this.contactsToPopoverContent(contacts);
        }

        self.attr("data-content", this.contactsContent);
        self.popover({
            html: true,
            //content: this.contactsContent
        });
        self.popover('show');

        setTimeout(function () {
            self.popover('hide');
        }, 5000);
    },

    contactsToPopoverContent: function (contacts) {
        var grouped = _.chain(contacts)
            .map(function (contact) {
                return {
                    type: contact.type,
                    data: contact.data
                }
            })
            .groupBy('type')
            .value();

        var popoverContactContent = _.keys(grouped).map(function (key) {
            return '<b>' + key + '</b> - ' + grouped[key].map(function (contact) {
                return contact.data;
            }).join(", ");
        }).join('<br>');

        return popoverContactContent;
    },

    reviewersContactsFetch: function (popoverRender) {
        var that = this;

        var fountContacts = [];
        var now = new Date().getTime();
        var contactsNorExistsText = "Contacts not found";

        var reviewersForRelationship = (that.model.get('object').reviewers || []).filter(function (reviewer) {
            return !_.isEmpty(reviewer.personId) && !_.isEmpty(reviewer.organizationId);
        });

        if (reviewersForRelationship.length == 0) {
            popoverRender(contactsNorExistsText);
            return;
        }

        reviewersForRelationship.forEach(function (reviewer, index) {

            var isLast = (reviewersForRelationship.length - 1) === index;

            $.ajax({
                type: "GET",
                url: '/api/relation?systemRelationType=PERSON_ORGANIZATION&parentId=' + reviewer.personId,
                statusCode: {
                    200: function (response) {
                        var relations = response.filter(function (item) {
                            return item.child.id == reviewer.organizationId
                                && (item.startTime == 0 || item.startTime <= now)
                                && (item.endTime == 0 || item.endTime >= now);
                        });
                        relations.forEach(function (relation) {
                            (relation.contacts || []).filter(function (contact) {
                                return that.actualContactPredicate(contact, now);
                            }).forEach(function (contact) {
                                fountContacts.push(contact);
                            })
                        })

                        if (isLast) {
                            setTimeout(function () {
                                popoverRender(fountContacts.length == 0 ? contactsNorExistsText : that.contactsToPopoverContent(fountContacts));
                            }, 1000);
                        }
                    }
                },
                error: function (e) {
                    console.log(e);
                }
            });
        })
    },

    createRequest: function (event) {
        var that = this;
        that.triggerMethod('document:create:request', {
            documentId: that.model.get('id'),
            documentName: that.model.get('name')
        });
    },

    documentSelected: function (event) {
        this.model.set("selected", event.target.checked);
        console.log(this.model);
        this.triggerMethod('document:selected', {
            documentId: this.model.get("id"),
            addOrRemove: event.target.checked,
            isDocumentPreviewed: this.isDocumentPreviewedByUser(this.getOption('username') || '')
        });
    },

    downloadColor: function () {
        var that = this;
        var username = that.getOption('username') || '';
        return this.isDocumentPreviewedByUser(username) ? that.downloadedAndPreviewedColor : that.notDownloadedAndPreviewedColor;
    },

    viewDocument: function () {
        var that = this;
        setTimeout(function () {
            $(that.ui.previewDoc).css("color", that.downloadedAndPreviewedColor);
            that.triggerMethod('refresh:model', {model: that.model});
        }, 5000);
    },

    isDocumentPreviewedByUser: function (username) {
        return (this.model.get('object').downloadedOrPreviewedSigners || []).filter(function (signer) {
            return signer == username;
        }).length > 0;
    },

    getDeliveryConf: function () {
        var conf = {};
        var document = this.model.get('object');
        if (document.lastDeliveredTime > 0) {
            conf = {
                deliveryColor: 'green',
                deliveryTitle: 'Delivered'
            }
        } else if (document.lastDeliveredTime == 0 && document.lastSentTime > 0) {
            conf = {
                deliveryColor: 'orange',
                deliveryTitle: 'Sent'
            }
        } else if (document.lastSentTime == 0) {
            conf = {
                deliveryColor: '#000000',
                deliveryTitle: 'Not sent'
            }
        }
        return conf;
    },

    getRevieweresNames: function () {
        var that = this;
        var result = {};
        var relations = that.model.get('relations') || [];
        relations.filter(function (item) {
            return item.parentId == that.model.get('id')
                && (item.systemRelationType == 'PERSON_REVIEW_REQUEST' ||
                    item.systemRelationType == 'ORGANIZATION_REVIEW_REQUEST' ||
                    item.systemRelationType == 'ORGANIZATION_REVIEW_FINISHED_REQUEST' ||
                    item.systemRelationType == 'PERSON_REVIEW_FINISHED_REQUEST' ||
                    item.systemRelationType == 'PERSON_REVIEW_DELETED' ||
                    item.systemRelationType == 'ORGANIZATION_REVIEW_DELETED');
        }).map(function (relation) {
            if (relation.child.object.lastName && relation.child.object.firstName)
                result[relation.child.id] = utils.formatPerson(relation.child.object)
            else
                result[relation.child.id] = relation.child.name ? relation.child.name.toUpperCase() : "";
        });

        return result;
    },

    downloadedAndPreviewedColor: '#afc7dc',
    notDownloadedAndPreviewedColor: '#337ab7'
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(8), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});


var DocumentsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: DocumentItem,
    emptyView: EmptyView,

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    childViewEvents: {
        'document:create:request': 'createRequest',
        'document:selected': 'documentSelected',
        'refresh:model': 'refreshModel'
    },

    childViewOptions: function () {
        return {
            accessSignAction: this.accessSignAction,
            username: this.username,
            byAdmin: this.getOption('byAdmin'),
            showSendingMethods: this.getOption('showSendingMethods')
        };
    },

    initialize: function (options) {
        this.collection = options.collection;
        this.accessSignAction = options.accessSignAction;
        this.username = options.username;
    },

    createRequest: function (data) {
        this.triggerMethod('document:create:request', data);
    },

    documentSelected: function (data) {
        this.triggerMethod('document:selected', data);
    },

    refreshModel: function (data) {
        this.triggerMethod('refresh:model', data);
    },

    showLoading: function () {
        this.triggerMethod('loader:show');
    },

    hideLoading: function () {
        this.triggerMethod('loader:hide');
    },

    logError: function () {
        this.triggerMethod('error:log');
    },

    refreshChildren: function (ids) {
        var that = this;
        ids.forEach(function (id) {
            var currentChild = that.children.findByModel(that.collection.get({id: id}));
            var model = new DocumentModel({id: id});
            model.fetch(
                {
                    success: function () {
                        currentChild.model = model;
                        currentChild.render();
                    }
                }
            );
        });
    }
});


var DocumentsListView = Marionette.View.extend({
    template: require('../../templates/documents/documents-list.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        patientsSelect: '#patients-select',
        assignedToPersonsSelect: '#assigned-to-persons-select',
        signedByPersonsSelect: '#signed-by-persons-select',
        createdBySelect: '#created-by-select',
        assignedToOrganizationsSelect: '#assigned-to-organizations-select',
        signedByOrganizationsSelect: '#signed-by-organizations-select',
        uploaderPersonsSelect: '#uploader-persons-select',
        documentsStatisticsRegion: '#documents-statistics-content',
        documentsStatisticsAggregateRegion: '#documents-statistics-aggregate-content',
        setInitialViewModal: '#initial-view-modal'
    },

    ui: {
        filter: '#requests-filter',
        clearFilter: '#clear-filter',
        clearFilterContainer: '#clear-filter-container',
        createdAfter: '#createdAfter',
        createdBefore: '#createdBefore',
        objectCreatedAfter: '#docCreatedAfter',
        objectCreatedBefore: '#docCreatedBefore',
        statuses: '#element-statuses',
        intentions: '#element-intentions',
        doctypes: '#doctypes',
        deliveryStatuses: '#delivery-statuses',
        reviewed: '#reviewed',
        signDocuments: '#sign-all',
        signAndGetDocuments: '#sign-and-get',
        download: '#download',
        print: '#print',
        assignModalShow: '#assign',
        addPatientModalShow: '#add-patient',
        setDueModalShow: '#set-due',
        audit: '#audit',
        auditMore: '#audit-more',
        auditBulk: '#audit-bulk',
        allDocCheckbox: '#root_check',
        errorMessage: '#error-message',
        send: '#send',
        sendMore: '#send-more',
        sendBulk: '#send-bulk',
        addendum: "#addendum",

        markAs: '#mark-as',
        markAsSent: '#mark-as-sent',
        markAsDelivered: '#mark-as-delivered',

        export: '#export',
        exportBulk: '#export-bulk',

        timeFrameMonthly: "#time-frame-monthly-filtered",
        timeFrameWeekly: "#time-frame-weekly-filtered",
        timeFrameDaily: "#time-frame-daily-filtered",
        timeFrameSelected: "#time-frame-selected",

        //sentAfter: '#sent-after',
        //sentBefore: '#sent-before',
        dueAfter: '#due-after',
        dueBefore: '#due-before',
        deliveredAfter: '#delivered-after',
        deliveredBefore: '#delivered-before',
        signedAfter: '#signed-after',
        signedBefore: '#signed-before',
        removeCommentFilter: '#remove-comment-filter',

        showDocumentsStatistics: '#show-documents-statistics',
        documentsStatisticsModal: '#documents-statistics-modal',

        showDocumentsStatisticsAggregate: '#show-documents-statistics-aggregate',
        documentsStatisticsAggregateModal: '#documents-statistics-aggregate-modal',
        signBeforeLeaveConfirmationModal: '#sign-before-leave-confirmation-modal',

        sortHeader: '.sort-header',

        showMoreFilters: '#show-more-filters',
        moreFilters: '#more-filtes',

        signBeforeLeaveConfirmationSignButton: '#sign-before-leave-confirmation-sign',
        signBeforeLeaveConfirmationCancelButton: '#sign-before-leave-confirmation-cancel',
        signBeforeLeaveConfirmationCloseButton: '#sign-before-leave-confirmation-close',

        setAsInitialViewSortingReportForMe: '#set-initial-for-me',
        setAsInitialViewSortingReport: '#set-initial'
    },

    events: {
        'click @ui.filter': 'doFilter',
        'click @ui.clearFilter': 'clearFilter',
        'click @ui.signDocuments': 'onSignSelectedDocuments',
        'click @ui.signAndGetDocuments': 'signAndGet',
        'click @ui.allDocCheckbox': 'checkOrUncheckAllDocuments',
        'click @ui.download': 'download',
        'click @ui.print': 'print',
        'click @ui.assignModalShow': 'assignModalShow',
        'click @ui.addPatientModalShow': 'addPatientModalShow',
        'click @ui.setDueModalShow': 'setDueModalShow',
        'click @ui.audit': 'auditModalShow',
        'click @ui.auditBulk': 'auditBulkModalShow',
        'click @ui.send': 'sendModalShow',
        'click @ui.sendBulk': 'sendBulkModalShow',
        'click @ui.addendum': 'addAddendumModalShow',
        'click @ui.markAsSent': 'markAsSentModalShow',
        'click @ui.markAsDelivered': 'markAsDeliveredModalShow',
        'click @ui.export': 'exportModalShow',
        'click @ui.exportBulk': 'exportBulkModalShow',

        'click @ui.timeFrameMonthly': 'timeFrameMonthly',
        'click @ui.timeFrameWeekly': 'timeFrameWeekly',
        'click @ui.timeFrameDaily': 'timeFrameDaily',
        'click @ui.timeFrameSelected': 'timeFrameSelected',

        'click @ui.removeCommentFilter': 'onRemoveCommentFilter',

        'click @ui.showDocumentsStatistics': 'onShowDocumentsStatistics',
        'click @ui.showDocumentsStatisticsAggregate': 'onShowDocumentsStatisticsAggregate',

        'click @ui.sortHeader': 'onSort',

        "click @ui.showMoreFilters": 'showMoreFilters',

        "click @ui.setAsInitialViewSortingReportForMe": 'onSetAsInitialViewSortingReportForMe',
        "click @ui.setAsInitialViewSortingReport": 'onSetAsInitialViewSortingReport'
    },

    childViewEvents: {
        'document:create:request': 'createRequest',
        'document:selected': 'documentSelected',
        'refresh:model': 'refreshModel',
        'loader:show': 'showLoading',
        'loader:hide': 'hideLoading',
        'error:log': 'logError',

        // events from Aggregated report View
        'statistics:aggregate': 'onStaticticsAggregate',
        'aggregate:documents:selected': 'onDocumentsSelectedInAggregateReport',
        'aggregate:documents:unselected': 'onDocumentsUnselectedInAggregateReport',
        'aggregate:download': 'downloadFromAggregateReport',
        'aggregate:print': 'printFromAggregateReport',
        'aggregate:sign': 'signModalShowFromAggregateReport',
        'aggregate:assign': 'assignModalShowFromAggregateReport',
        'aggregate:add:patient': 'addPatientModalShowFromAggregateReport',
        'aggregate:add:addendum': 'addAddendumModalShowFromAggregateReport',
        'aggregate:set:due': 'setDueModalShowFromAggregateReport',
        'aggregate:audit': 'auditModalShowFromAggregateReport',
        'aggregate:send': 'sendModalShowFromAggregateReport',
        'aggregate:mark:as:sent': 'markAsSentModalShowFromAggregateReport',
        'aggregate:mark:as:delivered': 'markAsDeliveredModalShowFromAggregateReport'
    },

    documentsIds: [],
    notPreviewedDocumentsIds: [],

    constants: {
        maxNumberOfItemsInControlWithSuggester: 200,
        documentPatient: 'DOCUMENT_PATIENT',
        documentUploaderPerson: 'DOCUMENT_UPLOADER_PERSON',
        personReviewRequest: 'PERSON_REVIEW_REQUEST',
        personReviewFinishedRequest: 'PERSON_REVIEW_FINISHED_REQUEST',
        createdBy: 'DOCUMENT_ORGANIZATION',
        organizationReviewRequest: 'ORGANIZATION_REVIEW_REQUEST',
        organizationReviewFinishedRequest: 'ORGANIZATION_REVIEW_FINISHED_REQUEST',
        objectIntentionStatus: 'object_intention',
        objectDoctype: 'object_type',
        objectStatus: 'object_status'
    },

    initialize: function (options) {
        var collectionParams = [
            {key: 'page-size', value: Constants.pageCapacity}
        ];

        if (!utils.isParamExists(options.collectionParams || [], {key: 'sortby'})) {
            collectionParams.push({key: 'sortby', value: 'documentCreationTime'});
        }
        if (!utils.isParamExists(options.collectionParams || [], {key: 'sortdir'})) {
            collectionParams.push({key: 'sortdir', value: 'DESC'});
        }

        this.reviewElementStatuses = options.reviewElementStatuses;
        this.collection = new DocumentsCollection([],
            {params: utils.mergeCollectionParams(collectionParams, options.collectionParams || [])});

        this.accessSignAction = window.location.href.indexOf("toReview") > -1;
        this.isSimple = window.location.href.indexOf("simpleMode=true") > -1;
        this.notForToReview = window.location.href.indexOf("toReview") == -1;
        this.viewAllMode = this.notForToReview && !this.isSimple;
        this.params = utils.getDefaultListParams();

        this.signDocsCallbackForPager = options.signDocsCallbackForPager
    },

    templateContext: function () {
        var that = this;
        return {
            elementStatuses: _.values(that.reviewElementStatuses.toJSON()).filter(function (item) {
                return item != 'VIEWED';
            }).map(function (item) {
                return {
                    id: item,
                    name: utils.getDocumentStatus(item)
                }
            }),
            accessSignAction: this.accessSignAction,
            isSimple: this.isSimple,
            notForToReview: this.notForToReview,
            viewAllMode: this.viewAllMode,
            byAdmin: this.getOption('byAdmin'),
            getParam: function (key) {
                if (key == "object_externalIds_in")
                    return (that.params[key] || '').replace(Constants.barCodePrefix, "");
                else
                    return that.params[key] || '';
            },
            getDateParam: function (key) {
                if (that.params[key]) {
                    try {
                        return utils.longToDateTimeFormatted(Number(that.params[key]), 'MM/DD/YYYY');
                    } catch (e) {
                        console.log(e);
                        return undefined;
                    }

                }
                return undefined;
            },
            getDateTimeParam: function (key) {
                if (that.params[key]) {
                    try {
                        return utils.longToDateTimeFormatted(Number(that.params[key]), 'MM/DD/YYYY hh:mm A');
                    } catch (e) {
                        console.log(e);
                        return undefined;
                    }

                }
                return undefined;
            },
            isMd: that.getOption('isMd'),
            isOfficeAdministrator: that.getOption('isOfficeAdministrator'),
            isMedicalDirector: that.getOption('isMedicalDirector'),
            isManager: that.getOption('isManager'),
            isAdmin: that.getOption('isAdmin'),
            showSendingMethods: that.showSendingMethods(that),
            getClassesForSortingHeader: function (sortBy) {
                var classes = ["sortable"];
                if ((that.params["sortby"] || "documentCreationTime") === sortBy) {
                    if (that.params["sortdir"] === "ASC") {
                        classes.push("glyphicon glyphicon-triangle-top");
                        return classes.join(" ");
                    } else {
                        classes.push("glyphicon glyphicon-triangle-bottom");
                        return classes.join(" ");
                    }
                } else {
                    return classes.join(" ");
                }
            }
        }
    },

    showMoreFilters: function () {
        this.$('#more-filtes').toggle();
    },

    showSendingMethods: function (self) {
        /*return self.getOption('isOfficeAdministrator')
            || self.getOption('isMedicalDirector')
            || self.getOption('isManager')
            || self.getOption('isAdmin')
            || self.getOption('byAdmin');*/
        return false;
    },

    onRender: function () {
        var that = this;

        that.extraInit();

        that.collection.fetch({
            success: function () {
                that.showChildView('body', new DocumentsTableBody({
                    collection: that.collection,
                    accessSignAction: that.accessSignAction,
                    username: that.getOption('username'),
                    byAdmin: that.getOption('byAdmin'),
                    showSendingMethods: that.showSendingMethods(that)
                }));
            }
        });

        if (!that.isSimple) {

            if (typeof that.params[that.constants.createdBy] != "undefined") {

                var collectionCreatedBy = new EntitiesCollection([],
                    {
                        params: (Array.isArray(that.params[that.constants.createdBy])
                            ? that.params[that.constants.createdBy]
                            : [that.params[that.constants.createdBy]])
                            .map(function (id) {
                                return {
                                    key: 'id',
                                    value: id
                                }
                            })
                    });
                collectionCreatedBy.fetch(
                    {
                        success: function () {
                            var items = collectionCreatedBy.models.map(function (model) {
                                return model.attributes;
                            });
                            that.showCreatedBySelect(items);
                        },
                        error: function () {
                            that.showCreatedBySelect();
                        }
                    }
                );
            } else {
                that.showCreatedBySelect();
            }

            if (typeof that.params[that.constants.personReviewRequest] != "undefined") {

                var collectionPersonReviewRequest = new EntitiesCollection([],
                    {
                        params: (Array.isArray(that.params[that.constants.personReviewRequest])
                            ? that.params[that.constants.personReviewRequest]
                            : [that.params[that.constants.personReviewRequest]])
                            .map(function (id) {
                                return {
                                    key: 'id',
                                    value: id
                                }
                            })
                    });
                collectionPersonReviewRequest.fetch(
                    {
                        success: function () {
                            var items = collectionPersonReviewRequest.models.map(function (model) {
                                return model.attributes;
                            });
                            that.showAssignedToPersonsSelect(items);
                        },
                        error: function () {
                            that.showAssignedToPersonsSelect();
                        }
                    }
                );
            } else {
                that.showAssignedToPersonsSelect();
            }

            if (typeof that.params[that.constants.organizationReviewRequest] != "undefined") {

                var collectionOrganizationReviewRequest = new EntitiesCollection([],
                    {
                        params: (Array.isArray(that.params[that.constants.organizationReviewRequest])
                            ? that.params[that.constants.organizationReviewRequest]
                            : [that.params[that.constants.organizationReviewRequest]])
                            .map(function (id) {
                                return {
                                    key: 'id',
                                    value: id
                                }
                            })
                    });
                collectionOrganizationReviewRequest.fetch(
                    {
                        success: function () {
                            var items = collectionOrganizationReviewRequest.models.map(function (model) {
                                return model.attributes;
                            });
                            that.showAssignedToOrganizationsSelect(items);
                        },
                        error: function () {
                            that.showAssignedToOrganizationsSelect();
                        }
                    }
                );
            } else {
                that.showAssignedToOrganizationsSelect();
            }

            if (typeof that.params[that.constants.documentPatient] != "undefined") {

                var collectionDocumentPatient = new EntitiesCollection([],
                    {
                        params: (Array.isArray(that.params[that.constants.documentPatient])
                            ? that.params[that.constants.documentPatient]
                            : [that.params[that.constants.documentPatient]])
                            .map(function (id) {
                                return {
                                    key: 'id',
                                    value: id
                                }
                            })
                    });
                collectionDocumentPatient.fetch(
                    {
                        success: function () {
                            var patients = collectionDocumentPatient.models.map(function (model) {
                                return model.attributes;
                            }).filter(that.isPatientFilter);
                            that.showPatientsSelect(patients);
                        },
                        error: function () {
                            that.showPatientsSelect();
                        }
                    }
                );

            } else {
                that.showPatientsSelect();
            }

            // if (typeof that.params[that.constants.personReviewFinishedRequest] != "undefined"
            //     && typeof that.params[that.constants.personReviewRequest] == "undefined") {
            if (typeof that.params[that.constants.personReviewFinishedRequest] != "undefined") {

                var collectionPersonReviewFinishedRequest = new EntitiesCollection([],
                    {
                        params: (Array.isArray(that.params[that.constants.personReviewFinishedRequest])
                            ? that.params[that.constants.personReviewFinishedRequest]
                            : [that.params[that.constants.personReviewFinishedRequest]])
                            .map(function (id) {
                                return {
                                    key: 'id',
                                    value: id
                                }
                            })
                    });
                collectionPersonReviewFinishedRequest.fetch(
                    {
                        success: function () {
                            var items = collectionPersonReviewFinishedRequest.models.map(function (model) {
                                return model.attributes;
                            });
                            that.showSignedByPersonsSelect(items);
                        },
                        error: function () {
                            that.showSignedByPersonsSelect();
                        }
                    }
                );
            } else {
                that.showSignedByPersonsSelect();
            }

            if (typeof that.params[that.constants.documentUploaderPerson] != "undefined") {

                var collectionPersonUploader = new EntitiesCollection([],
                    {
                        params: (Array.isArray(that.params[that.constants.documentUploaderPerson])
                            ? that.params[that.constants.documentUploaderPerson]
                            : [that.params[that.constants.documentUploaderPerson]])
                            .map(function (id) {
                                return {
                                    key: 'id',
                                    value: id
                                }
                            })
                    });
                collectionPersonUploader.fetch(
                    {
                        success: function () {
                            var items = collectionPersonUploader.models.map(function (model) {
                                return model.attributes;
                            });
                            that.showUploaderPersonsSelect(items);
                        },
                        error: function () {
                            that.showUploaderPersonsSelect();
                        }
                    }
                );
            } else {
                that.showUploaderPersonsSelect();
            }

            // if (typeof that.params[that.constants.organizationReviewFinishedRequest] != "undefined"
            //     && typeof that.params[that.constants.organizationReviewRequest] == "undefined") {
            if (typeof that.params[that.constants.organizationReviewFinishedRequest] != "undefined") {

                var collectionOrganizationReviewFinishedRequest = new EntitiesCollection([],
                    {
                        params: (Array.isArray(that.params[that.constants.organizationReviewFinishedRequest])
                            ? that.params[that.constants.organizationReviewFinishedRequest]
                            : [that.params[that.constants.organizationReviewFinishedRequest]])
                            .map(function (id) {
                                return {
                                    key: 'id',
                                    value: id
                                }
                            })
                    });
                collectionOrganizationReviewFinishedRequest.fetch(
                    {
                        success: function () {
                            var items = collectionOrganizationReviewFinishedRequest.models.map(function (model) {
                                return model.attributes;
                            });
                            that.showSignedByOrganizationsSelect(items);
                        },
                        error: function () {
                            that.showSignedByOrganizationsSelect();
                        }
                    }
                );
            } else {
                that.showSignedByOrganizationsSelect();
            }
        }

        this.$('#createdAfter').datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });
        this.$('#createdBefore').datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });
        this.$('#docCreatedBefore').datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });
        this.$('#docCreatedAfter').datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });

        this.$('#delivered-after').datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });
        this.$('#delivered-before').datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });

        this.$('#signed-after').datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });
        this.$('#signed-before').datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });
        /*this.ui.sentAfter.datepicker({
         format: 'mm/dd/yyyy',
         clearBtn: true
         }).on('changeDate', function (e) {
         $(this).datepicker('hide');
         });
         this.ui.sentBefore.datepicker({
         format: 'mm/dd/yyyy',
         clearBtn: true
         }).on('changeDate', function (e) {
         $(this).datepicker('hide');
         });*/

        this.ui.dueAfter.datetimepicker({
            showClear: true,
            showClose: true,
            format: 'MM/DD/YYYY hh:mm A'
        });
        if (typeof that.params["object_dueDate_from"] !== 'undefined') {
            this.ui.dueAfter.data("DateTimePicker").date(utils.longToDateTimeFormatted(Number(that.params["object_dueDate_from"]), 'MM/DD/YYYY hh:mm A'));
        }

        this.ui.dueBefore.datetimepicker({
            showClear: true,
            showClose: true,
            format: 'MM/DD/YYYY hh:mm A'
        });
        if (typeof that.params["object_dueDate_to"] !== 'undefined') {
            this.ui.dueBefore.data("DateTimePicker").date(utils.longToDateTimeFormatted(Number(that.params["object_dueDate_to"]), 'MM/DD/YYYY hh:mm A'));
        }

        this.ui.statuses.selectize({
            plugins: ['remove_button'],
            inputClass: 'form-control selectize-input normal-width selectized',
            placeholder: 'Status',
            valueField: 'id',
            labelField: 'name',
            options: _.keys(Dicts.documentStatuses)/*.filter(function (key) {
                return key !== 'UNREVIEWED';
            })*/.map(function (key) {
                return {
                    id: key,
                    name: Dicts.documentStatuses[key].toUpperCase()
                }
            }),
            items: function () {
                if (typeof that.params[that.constants.objectStatus] != "undefined") {
                    return Array.isArray(that.params[that.constants.objectStatus])
                        ? that.params[that.constants.objectStatus]
                        : [that.params[that.constants.objectStatus]];
                } else {
                    return [];
                }
            }(),
            highlight: true,
            openOnFocus: true
        });

        this.ui.intentions.selectize({
            plugins: ['remove_button'],
            inputClass: 'form-control selectize-input normal-width selectized',
            placeholder: 'Request',
            valueField: 'id',
            labelField: 'name',
            options: _.keys(Dicts.documentIntention).map(function (key) {
                return {
                    id: key,
                    name: Dicts.documentIntention[key].toUpperCase()
                }
            }),
            items: function () {
                if (typeof that.params[that.constants.objectIntentionStatus] != "undefined") {
                    return Array.isArray(that.params[that.constants.objectIntentionStatus])
                        ? that.params[that.constants.objectIntentionStatus]
                        : [that.params[that.constants.objectIntentionStatus]];
                } else {
                    return [];
                }
            }(),
            highlight: true,
            openOnFocus: true
        });

        this.ui.doctypes.selectize({
            plugins: ['remove_button'],
            inputClass: 'form-control selectize-input normal-width selectized',
            placeholder: 'Document type',
            valueField: 'id',
            labelField: 'name',
            options: _.keys(Dicts.documentTypes).map(function (key) {
                return {
                    id: key,
                    name: Dicts.documentTypes[key]
                }
            }),
            items: function () {
                if (typeof that.params[that.constants.objectDoctype] != "undefined") {
                    return Array.isArray(that.params[that.constants.objectDoctype])
                        ? that.params[that.constants.objectDoctype]
                        : [that.params[that.constants.objectDoctype]];
                } else {
                    return [];
                }
            }(),
            highlight: true,
            openOnFocus: true
        });

        /*this.ui.sentStatuses.selectize({
         allowEmptyOption: false,
         placeholder: 'Sent status (All)',
         inputClass: 'form-control selectize-input normal-width'
         });*/

        this.ui.deliveryStatuses.selectize({
            allowEmptyOption: false,
            placeholder: 'Delivery Status',
            inputClass: 'form-control selectize-input'
        });

        that.ui.documentsStatisticsModal.on("hidden.bs.modal", function () {
            that.detachChildView('documentsStatisticsRegion');
        });
        that.ui.documentsStatisticsAggregateModal.on("hidden.bs.modal", function () {
            that.detachChildView('documentsStatisticsAggregateRegion');
            that.checkOrUncheckAllDocumentsInner(false);
        });

        if (utils.isUrlWoExtraQueryParameters()) {
            that.ui.clearFilterContainer.hide();
        } else {
            that.ui.clearFilterContainer.show();
        }

        that.documentsIds = [];
        that.notPreviewedDocumentsIds = [];
    },

    extraInit: function () {
        console.log('extraInit');
        var that = this;
        window.setTimeout(function () {
            var params = $.deparam(window.location.hash.replace('#documents', '').replace('?', ''));
            if (params["initial-view"]) {
                console.log(params["initial-view"]);
                if (params["initial-view"] == "sorting-report") {
                    that.onShowDocumentsStatisticsAggregate();
                    delete that.params["initial-view"];
                }
            }
        }, 500);
    },

    createRequest: function (data) {
        var that = this;
        that.triggerMethod('request:create', data);
    },

    initFilterParams: function () {
        var that = this;

        $('.filter-field').each(function (i, element) {
            if ($(element).attr('name')) {
                var names = $(element).attr('name').split(',');
                for (var name in names) {
                    if ($(element).val() && $(element).val() != 'all') {
                        if (names[name] == "object_externalIds_in")
                            that.params[names[name]] = Constants.barCodePrefix + $(element).val();
                        else
                            that.params[names[name]] = $(element).val();
                    } else {
                        delete that.params[names[name]];
                    }
                }
            }
        });

        var statuses = that.ui.statuses.val();
        if (_.isEmpty(statuses)) {
            delete that.params[that.constants.objectStatus];
        } else {
            that.params[that.constants.objectStatus] = statuses.split(',');
        }

        var intentionStatuses = that.ui.intentions.val();
        if (_.isEmpty(intentionStatuses)) {
            delete that.params[that.constants.objectIntentionStatus];
        } else {
            that.params[that.constants.objectIntentionStatus] = intentionStatuses.split(',');
        }


        var doctypes = that.ui.doctypes.val();
        if (_.isEmpty(doctypes)) {
            delete that.params[that.constants.objectDoctype];
        } else {
            that.params[that.constants.objectDoctype] = doctypes.split(',');
        }

        if (this.ui.deliveryStatuses.val() == "delivered") {
            that.params["object_lastDeliveredTime_from"] = 1;
            delete that.params["object_lastDeliveredTime"];
            delete that.params["object_lastSentTime_from"];
            delete that.params["object_lastSentTime"];
        } else if (this.ui.deliveryStatuses.val() == "not_delivered") {
            that.params["object_lastDeliveredTime"] = 0;
            that.params["object_lastSentTime_from"] = 1;
            this.ui.deliveredAfter.val('');
            delete that.params["object_lastDeliveredTime_from"];
            delete that.params["object_lastSentTime"];
        } else if (this.ui.deliveryStatuses.val() == "not_sent") {
            that.params["object_lastSentTime"] = 0;
            this.ui.deliveredAfter.val('');
            delete that.params["object_lastDeliveredTime_from"];
            delete that.params["object_lastDeliveredTime"];
            delete that.params["object_lastSentTime_from"];
        } else {
            delete that.params["object_lastDeliveredTime"];
            delete that.params["object_lastDeliveredTime_from"];
            delete that.params["object_lastSentTime_from"];
            delete that.params["object_lastSentTime"];
        }

        var documentPatientsIds = that.getChildView('patientsSelect').getSelectedIdsList();
        if (documentPatientsIds.length > 0) {
            that.params[that.constants.documentPatient] = documentPatientsIds;
        } else {
            delete (that.params[that.constants.documentPatient]);
        }

        var createdByValues = that.getChildView('createdBySelect').getSelectedIdsList();
        if (createdByValues.length > 0) {
            that.params[that.constants.createdBy] = createdByValues;
        } else {
            delete (that.params[that.constants.createdBy]);
        }

        var assignedToPersonValues = that.getChildView('assignedToPersonsSelect').getSelectedIdsList();
        var assignedToOrganizationValues = that.getChildView('assignedToOrganizationsSelect').getSelectedIdsList();
        var signedByPersonValues = that.getChildView('signedByPersonsSelect').getSelectedIdsList();
        var signedByOrganizationValues = that.getChildView('signedByOrganizationsSelect').getSelectedIdsList();
        var uploaderPersonValues = that.getChildView('uploaderPersonsSelect').getSelectedIdsList();

        if (assignedToPersonValues.length > 0) {
            that.params[that.constants.personReviewRequest] = assignedToPersonValues;
        } else {
            delete (that.params[that.constants.personReviewRequest]);
        }

        if (assignedToOrganizationValues.length > 0) {
            that.params[that.constants.organizationReviewRequest] = assignedToOrganizationValues;
        } else {
            delete (that.params[that.constants.organizationReviewRequest]);
        }

        if (signedByPersonValues.length > 0) {
            that.params[that.constants.personReviewFinishedRequest] = signedByPersonValues;
        } else {
            delete (that.params[that.constants.personReviewFinishedRequest]);
        }

        if (uploaderPersonValues.length > 0) {
            that.params[that.constants.documentUploaderPerson] = uploaderPersonValues;
        } else {
            delete (that.params[that.constants.documentUploaderPerson]);
        }

        if (signedByOrganizationValues.length > 0) {
            that.params[that.constants.organizationReviewFinishedRequest] = signedByOrganizationValues;
        } else {
            delete (that.params[that.constants.organizationReviewFinishedRequest]);
        }

        if (this.ui.createdAfter.val() != undefined && this.ui.createdAfter.val() != '')
            this.params['from_createdTime'] = utils.dateToLong(this.ui.createdAfter.val());
        else
            delete this.params['from_createdTime'];
        if (this.ui.createdBefore.val() != undefined && this.ui.createdBefore.val() != '')
            this.params['to_createdTime'] = utils.dateToLong(this.ui.createdBefore.val());
        else
            delete this.params['to_createdTime'];

        if (this.ui.objectCreatedAfter.val() != undefined && this.ui.objectCreatedAfter.val() != '')
            this.params['object_createdTime_from'] = utils.dateToLong(this.ui.objectCreatedAfter.val());
        else
            delete this.params['object_createdTime_from'];
        if (this.ui.objectCreatedBefore.val() != undefined && this.ui.objectCreatedBefore.val() != '')
            this.params['object_createdTime_to'] = utils.dateToLong(this.ui.objectCreatedBefore.val());
        else
            delete this.params['object_createdTime_to'];

        /*if (this.ui.sentAfter.val() != undefined && this.ui.sentAfter.val() != '')
         this.params['object_lastSentTime_from'] = utils.dateToLong(this.ui.sentAfter.val());
         else
         delete this.params['object_lastSentTime_from'];
         if (this.ui.sentBefore.val() != undefined && this.ui.sentBefore.val() != '')
         this.params['object_lastSentTime_to'] = utils.dateToLong(this.ui.sentBefore.val());
         else
         delete this.params['object_lastSentTime_to'];*/

        if (this.ui.dueAfter.val() != undefined && this.ui.dueAfter.val() != '')
            this.params['object_dueDate_from'] = utils.dateToLong(this.ui.dueAfter.val());
        else
            delete this.params['object_dueDate_from'];
        if (this.ui.dueBefore.val() != undefined && this.ui.dueBefore.val() != '')
            this.params['object_dueDate_to'] = utils.dateToLong(this.ui.dueBefore.val());
        else
            delete this.params['object_dueDate_to'];

        if (this.ui.deliveredAfter.val() != undefined && this.ui.deliveredAfter.val() != '')
            this.params['object_lastDeliveredTime_from'] = utils.dateToLong(this.ui.deliveredAfter.val());
        else if (this.ui.deliveryStatuses.val() == undefined) {
            delete this.params['object_lastDeliveredTime_from'];
        }

        if (this.ui.deliveredBefore.val() != undefined && this.ui.deliveredBefore.val() != '')
            this.params['object_lastDeliveredTime_to'] = utils.dateToLong(this.ui.deliveredBefore.val());
        else
            delete this.params['object_lastDeliveredTime_to'];

        if (this.ui.signedAfter.val() != undefined && this.ui.signedAfter.val() != '')
            this.params['object_signedTime_from'] = utils.dateToLong(this.ui.signedAfter.val());
        else
            delete this.params['object_signedTime_from'];

        if (this.ui.signedBefore.val() != undefined && this.ui.signedBefore.val() != '')
            this.params['object_signedTime_to'] = utils.dateToLong(this.ui.signedBefore.val());
        else
            delete this.params['object_signedTime_to'];

    },

    doFilter: function () {

        this.initFilterParams();
        this.params.page = 0;

        console.log('Hashing to ' + utils.getCleanBaseHash() + "?" + utils.objectToQueryParams(this.params));

        window.location.hash = utils.getCleanBaseHash() + "?" + utils.objectToQueryParams(this.params);
    },

    onRemoveCommentFilter: function () {
        delete this.params["commentId"];
        window.location.hash = utils.getCleanBaseHash() + "?" + utils.objectToQueryParams(this.params);
    },

    clearFilter: function () {
        utils.redirectToUrlWoExtraQueryParameters();
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    },

    enableButtons: function () {
        this.ui.download.removeAttr("disabled");
        this.ui.print.removeAttr("disabled");
        this.ui.assignModalShow.removeAttr("disabled");
        this.ui.addPatientModalShow.removeAttr("disabled");
        this.ui.setDueModalShow.removeAttr("disabled");
        this.ui.audit.removeAttr("disabled");
        this.ui.send.removeAttr("disabled");
        this.ui.addendum.removeAttr("disabled");
        this.ui.markAs.removeAttr("disabled");
        this.ui.export.removeAttr("disabled");
        this.ui.timeFrameSelected.removeAttr("disabled");
    },

    disableButtons: function () {
        this.ui.download.attr("disabled", "true");
        this.ui.print.attr("disabled", "true");
        this.ui.assignModalShow.attr("disabled", "true");
        this.ui.addPatientModalShow.attr("disabled", "true");
        this.ui.setDueModalShow.attr("disabled", "true");
        this.ui.audit.attr("disabled", "true");
        this.ui.send.attr("disabled", "true");
        this.ui.addendum.attr("disabled", "true");
        this.ui.markAs.attr("disabled", "true");
        this.ui.export.attr("disabled", "true");
        this.ui.timeFrameSelected.attr("disabled", "true");
    },


    enableSignButtons: function () {
        this.ui.signDocuments.removeAttr("disabled");
        this.ui.signAndGetDocuments.removeAttr("disabled");
    },

    disableSignButtons: function () {
        this.ui.signDocuments.attr("disabled", "true");
        this.ui.signAndGetDocuments.attr("disabled", "true");
    },

    documentSelected: function (data) {
        var that = this;
        if (data.addOrRemove) {
            if (data.isDocumentPreviewed) {
                this.documentsIds.push(data.documentId);
            } else {
                this.documentsIds.push(data.documentId);
                this.notPreviewedDocumentsIds.push(data.documentId);
            }
        } else {
            this.documentsIds = (this.documentsIds || []).filter(function (item) {
                return item !== data.documentId
            });
            this.notPreviewedDocumentsIds = (this.notPreviewedDocumentsIds || []).filter(function (item) {
                return item !== data.documentId
            });
        }
        this.documentsIds = _.uniq(this.documentsIds);
        this.notPreviewedDocumentsIds = _.uniq(this.notPreviewedDocumentsIds);


        if (this.documentsIds.length - this.notPreviewedDocumentsIds.length == 0 || this.notPreviewedDocumentsIds.length > 0) {
            this.disableSignButtons();
            //this.signDocsCallbackForPager.signDocuments = null;
        } else {
            this.enableSignButtons();
            /*this.signDocsCallbackForPager.signDocuments = function (fn) {
                return that.signDocumentsBeforePageChanged(fn, that);
            };*/
        }

        if (this.documentsIds.length == 0 && this.notPreviewedDocumentsIds.length == 0) {
            this.disableButtons();
        } else {
            this.enableButtons();
        }

        if (/*this.getOption('isMd')*/ true) {
            if (this.notPreviewedDocumentsIds.length == 0) {
                this.showDocumentNotPreviewedMessage('hide');
            } else {
                this.showDocumentNotPreviewedMessage('show');
            }
        }

        if (this.documentsIds.length == 0) {
            this.signDocsCallbackForPager.signDocuments = null;
        } else {
            this.signDocsCallbackForPager.signDocuments = function (fn) {
                return that.signDocumentsBeforePageChanged(fn, that);
            };
        }
    },

    showDocumentNotPreviewedMessage: function (mode) {
        if (/*this.accessSignAction*/ true) {
            if (mode == 'hide') {
                this.ui.errorMessage.empty();
            } else if (mode == 'show') {
                this.ui.errorMessage.html('All documents should be viewed or downloaded before signing');
            }
        }
    },

    checkOrUncheckAllDocuments: function (event) {
        this.checkOrUncheckAllDocumentsInner(event.target.checked);
    },

    checkOrUncheckAllDocumentsInner: function (checked) {
        var that = this;

        that.collection.forEach(function (model) {
            model.set("selected", checked);
        });

        if (checked) {
            $('.child_checkbox').prop('checked', true);

            that.documentsIds = that.collection.map(function (model) {
                return model.get('id');
            });

            that.notPreviewedDocumentsIds = that.collection.filter(function (model) {
                return (model.get('object').downloadedOrPreviewedSigners || []).filter(function (signer) {
                    return signer == that.getOption('username');
                }).length == 0;
            }).map(function (model) {
                return model.get('id');
            });

            if (that.notPreviewedDocumentsIds.length > 0) {
                that.showDocumentNotPreviewedMessage('show');
            }

            if (that.documentsIds.length > 0 && that.notPreviewedDocumentsIds.length == 0) {
                that.enableSignButtons();
                /*that.signDocsCallbackForPager.signDocuments = function (fn) {
                    return that.signDocumentsBeforePageChanged(fn, that);
                };*/
            }
            if (that.documentsIds.length > 0) {
                that.enableButtons();
                that.signDocsCallbackForPager.signDocuments = function (fn) {
                    return that.signDocumentsBeforePageChanged(fn, that);
                };
            }
        } else {
            that.documentsIds = [];
            that.notPreviewedDocumentsIds = [];
            that.disableButtons();
            that.disableSignButtons();
            $('.child_checkbox').prop('checked', false);
            that.showDocumentNotPreviewedMessage('hide');
            that.signDocsCallbackForPager.signDocuments = null;
        }

        console.log(that.documentsIds);
    },

    onSignSelectedDocuments: function () {
        var that = this;
        this.signDocuments(function (documentsIds) {
            that.triggerMethod('document:list:refresh', null);
        });
    },

    signDocuments: function (fn, fn2) {
        var that = this;
        this.triggerMethod('sign:documents', {
            ids: that.documentsIds.join(),
            action: this.sendToServer,
            fn: fn,
            cancelAction: fn2
        });

    },
    sendToServer: function (fn, ids, password) {
        var that = this;
        utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/document/sign/documents',
            data: {
                documentsIds: ids,
                status: 'SIGNED',
                password: password
            },
            dataType: 'text',
            statusCode: {
                200: function (response) {
                    utils.hideSpinner();

                    window.setTimeout(function () {
                        var sended = ids.split(",").filter(function (item) {
                            return item != '';
                        });
                        var received = (response.split(",") || []).filter(function (item) {
                            return item != '';
                        });
                        if (sended.length != received.length) {
                            var n = sended.length - received.length;
                            notificationsChannel.request('show:notification',
                                n + " documents were not signed. Signed documents should be viewed at least once or user doesn't have permissions to sign.");
                        } else {
                            $.notify({
                                message: 'Documents were signed successfully'
                            }, {
                                type: 'success',
                                z_index: 2000,
                            });
                        }
                    }, 0);

                    if (typeof fn == "function" && response != '')
                        fn(response);
                }
            },
            error: function (e) {
                utils.hideSpinner();
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
                }
            }
        });
    },
    signAndGet: function () {
        var that = this;
        that.signDocuments(this.attachmentsDownloadFn);
    },

    download: function () {
        this.attachmentsDownloadFn(this.documentsIds.join(), true);
    },

    attachmentsDownloadFn: function (docsIds, partialRefreshModels) {
        var that = this;
        var idsList = docsIds.split(",");
        if (idsList.length == 1) {
            window.open("/api/document/download/" + docsIds);
        } else if (idsList.length > 1) {
            window.open("/api/document/download/multi/" + docsIds);
        }

        if (partialRefreshModels) {
            setTimeout(function () {
                idsList.forEach(function (docId) {
                    var oldDocumentModel = that.collection.findWhere({id: docId});
                    that.refreshModel({model: oldDocumentModel});
                });
            }, 4000);

            setTimeout(function () {
                idsList.forEach(function (docId) {
                    var oldDocumentModel = that.collection.findWhere({id: docId});
                    that.refreshModel({model: oldDocumentModel});
                });
            }, 12000);
        }
    },

    print: function () {
        window.open("/api/document/print/" + this.documentsIds.join(","));
    },

    assignModalShow: function (woResponseEvent, fetchDocsById) {
        var that = this;
        var byAdmin = that.getOption('byAdmin');
        var documentsIds = that.documentsIds;
        if (fetchDocsById) {
            var documentsCollection = new DocumentsCollection([], {
                params: documentsIds.map(function (id) {
                    return {
                        key: 'id',
                        value: id
                    }
                })
            });
            documentsCollection.fetch({
                success: function () {
                    that.assignModalShowInner(woResponseEvent, documentsCollection, documentsIds, byAdmin);
                },
                error: function (e) {
                    console.log(e);
                }
            });
        } else {
            that.assignModalShowInner(woResponseEvent, that.collection, documentsIds, byAdmin);
        }
    },

    assignModalShowInner: function (woResponseEvent, collection, documentsIds, byAdmin) {
        var reviewersAndDocuments = this.buildAndGetDocumentsWithReviewers(collection, documentsIds, byAdmin);
        var getReviewerName = this.getReviewerNamesCombiner(documentsIds);
        this.triggerMethod("document:reviewers:add:or:update", {
            reviewersAndDocuments: reviewersAndDocuments,
            documentsIds: documentsIds,
            getReviewerName: getReviewerName,
            woResponseEvent: woResponseEvent
        });
    },

    buildAndGetDocumentsWithReviewers: function (collection, documentsIds, isByAdmin) {
        var resultData = {};
        var delimeter = '~~~';

        collection.filter(function (model) {
            return documentsIds.indexOf(model.get('id')) > -1;
        }).forEach(function (model) {
            var id = model.get('id');
            (model.get('object').reviewers || [])
                .filter(function (reviewer) {
                    if (isByAdmin)
                        return true;
                    return reviewer.status === 'UNREVIEWED'
                        || reviewer.status === 'IN_REVIEW'
                        || reviewer.status === 'UNDER_REVIEW'
                        || reviewer.status === 'DELETED';
                })
                .forEach(function (reviewer) {
                    var reviewersUniqueValue = (reviewer.organizationId ? reviewer.organizationId : ' ') + delimeter
                        + (reviewer.personId ? reviewer.personId : ' ') + delimeter
                        + reviewer.mandatory + delimeter
                        + reviewer.status;
                    if (!resultData[reviewersUniqueValue]) {
                        resultData[reviewersUniqueValue] = [id];
                    } else {
                        resultData[reviewersUniqueValue].push(id);
                    }
                });
        });

        return (_.keys(resultData) || []).map(function (key) {
            var unparsed = key.split(delimeter);
            var organizationId = unparsed[0].trim();
            var personId = unparsed[1].trim();
            var mandatory = unparsed[2].trim() == 'true' ? true : false;
            var status = unparsed[3].trim();
            return {
                originalReviewer: {
                    organizationId: organizationId,
                    personId: personId,
                    mandatory: mandatory,
                    status: status
                },
                beingUpdatedReviewer: {
                    organizationId: organizationId,
                    personId: personId,
                    mandatory: mandatory,
                    status: status
                },
                documentsIds: resultData[key]
            };
        });
    },

    getReviewerNamesCombiner: function (documentsIds) {

        var idAndNames = {};

        this.collection.filter(function (model) {
            return documentsIds.indexOf(model.get('id')) > -1;
        }).forEach(function (model) {
            var id = model.get('id');
            (model.get('relations') || [])
                .filter(function (relation) {
                    return relation.child
                        && relation.child.id
                        && relation.child.name
                        && (relation.systemRelationType === 'PERSON_REVIEW_FINISHED_REQUEST'
                            || relation.systemRelationType === 'PERSON_REVIEW_REQUEST'
                            || relation.systemRelationType === 'ORGANIZATION_REVIEW_REQUEST'
                            || relation.systemRelationType === 'ORGANIZATION_REVIEW_FINISHED_REQUEST'
                            || relation.systemRelationType === 'ORGANIZATION_REVIEW_DELETED'
                            || relation.systemRelationType === 'PERSON_REVIEW_DELETED');
                })
                .map(function (relation) {
                    return {
                        id: relation.child.id,
                        name: relation.child.name
                    }
                })
                .forEach(function (row) {
                    idAndNames[row.id] = row.name;
                });
        });

        return function (id) {
            return idAndNames[id];
        };
    },

    addPatientModalShow: function (woResponseEvent) {
        this.triggerMethod("document:patient:add", {docIds: this.documentsIds, woResponseEvent: woResponseEvent});
    },

    addAddendumModalShow: function (woResponseEvent) {
        this.triggerMethod("document:add:addendum", {docIds: this.documentsIds, woResponseEvent: woResponseEvent});
    },

    setDueModalShow: function (woResponseEvent) {
        this.triggerMethod("document:due:set", {docIds: this.documentsIds, woResponseEvent: woResponseEvent});
    },

    signModalShow: function (callback) {
        var that = this;
        var sended = that.documentsIds;

        this.triggerMethod('sign:documents', {
            ids: that.documentsIds.join(),
            action: this.sendToServer,
            fn: function (handledDocumentIds) {
                console.log(handledDocumentIds);
                window.setTimeout(function () {
                    var received = (handledDocumentIds.split(",") || []).filter(function (item) {
                        return item != '';
                    });
                    callback(received, _.difference(sended, received));
                }, 0);
            },
            cancelAction: null
        });
    },

    auditModalShow: function (woResponseEvent) {
        this.triggerMethod("document:comment", {
            docIds: this.documentsIds,
            allFiltered: false,
            woResponseEvent: woResponseEvent
        });
    },

    auditBulkModalShow: function () {
        var that = this;
        this.triggerMethod("document:comment", {
            docIds: this.documentsIds,
            allFiltered: true,
            params: utils.objectToQueryParams(that.params)
        });
    },

    sendModalShow: function (woResponseEvent) {
        this.triggerMethod("document:send", {
            docIds: this.documentsIds,
            allFiltered: false,
            woResponseEvent: woResponseEvent
        });
    },

    sendBulkModalShow: function () {
        var that = this;
        this.triggerMethod("document:send", {
            docIds: this.documentsIds,
            allFiltered: true,
            params: utils.objectToQueryParams(that.params)
        });
    },

    addAddendumModalShow: function (woResponseEvent) {
        this.triggerMethod("document:add:addendum", {docIds: this.documentsIds, woResponseEvent: woResponseEvent});
    },

    markAsSentModalShow: function (woResponseEvent) {
        this.triggerMethod("document:mark:as", {
            docIds: this.documentsIds,
            mode: "sent",
            woResponseEvent: woResponseEvent
        });
    },

    markAsDeliveredModalShow: function (woResponseEvent) {
        this.triggerMethod("document:mark:as", {
            docIds: this.documentsIds,
            mode: "delivered",
            woResponseEvent: woResponseEvent
        });
    },

    exportModalShow: function (woResponseEvent) {
        this.triggerMethod("document:export", {
            docIds: this.documentsIds,
            allFiltered: false,
            woResponseEvent: woResponseEvent
        });
    },

    exportBulkModalShow: function () {
        var that = this;
        this.triggerMethod("document:export", {
            docIds: [],
            allFiltered: true,
            params: utils.objectToQueryParams(that.params)
        });
    },

    timeFrameMonthly: function () {
        var startOfMonth = new moment().startOf('month');
        var endOfMonth = new moment().endOf("month");
        this.timeFrame({
            object_createdTime_from: startOfMonth.toDate().getTime(),
            object_createdTime_to: endOfMonth.toDate().getTime()
        }, []);
    },

    timeFrameWeekly: function () {
        var startOfWeek = new moment().startOf('week');
        var endOfWeek = new moment().endOf("week");
        this.timeFrame({
            object_createdTime_from: startOfWeek.toDate().getTime(),
            object_createdTime_to: endOfWeek.toDate().getTime()
        }, []);
    },

    timeFrameDaily: function () {
        var startOfDay = new moment().startOf('day');
        var endOfDay = new moment().endOf("day");
        /*console.log(startOfDay);
        console.log(endOfDay);
        console.log(startOfDay.toDate());
        console.log(endOfDay.toDate());
        console.log(startOfDay.format("YYYY-DD-MM"));
        console.log(endOfDay.format("YYYY-DD-MM"));*/
        this.timeFrame({
            object_createdTime_from: startOfDay.toDate().getTime(),
            object_createdTime_to: endOfDay.toDate().getTime()
        }, []);
    },

    timeFrameSelected: function () {
        this.timeFrame({}, this.documentsIds);
    },

    timeFrame: function (extraParams, documentsIds) {
        var that = this;
        var params = utils.deepClone(that.params);
        _.keys(extraParams).forEach(function (key) {
            params[key] = extraParams[key];
        });

        var config = {
            params: params,
            url: '/api/document/export?' + utils.objectToQueryParams(params),
            exportType: "csv",
            documentIds: documentsIds,
            userTimezoneOffsetInHours: new Date().getTimezoneOffset() / 60
        };
        console.log(config);

        var form = document.createElement('form');
        form.setAttribute('target', '_blank');
        form.setAttribute('action', config.url);
        form.setAttribute('method', 'post');
        document.body.appendChild(form);

        var input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.setAttribute('name', "exportType");
        input.setAttribute('value', decodeURIComponent(config.exportType));
        form.appendChild(input);

        var input2 = document.createElement('input');
        input2.setAttribute('type', 'text');
        input2.setAttribute('name', "documentIds");
        input2.setAttribute('value', decodeURIComponent(config.documentIds.join(",")));
        form.appendChild(input2);

        var input3 = document.createElement('input');
        input3.setAttribute('type', 'text');
        input3.setAttribute('name', "userTimezoneOffsetInHours");
        input3.setAttribute('value', decodeURIComponent(config.userTimezoneOffsetInHours));
        form.appendChild(input3);

        form.submit();

        window.setTimeout(function () {
            document.body.removeChild(form);
        }, 0);
    },

    downloadFromAggregateReport: function () {
        this.download();
    },

    printFromAggregateReport: function () {
        this.print();
    },

    signModalShowFromAggregateReport: function (callback) {
        this.signModalShow(callback);
    },

    assignModalShowFromAggregateReport: function () {
        this.assignModalShow(true, true);
    },

    addPatientModalShowFromAggregateReport: function () {
        this.addPatientModalShow(true);
    },

    addAddendumModalShowFromAggregateReport: function () {
        this.addAddendumModalShow(true);
    },

    setDueModalShowFromAggregateReport: function () {
        this.setDueModalShow(true);
    },

    auditModalShowFromAggregateReport: function () {
        this.auditModalShow(true);
    },

    sendModalShowFromAggregateReport: function () {
        this.sendModalShow(true);
    },

    markAsSentModalShowFromAggregateReport: function () {
        this.markAsSentModalShow(true);
    },

    markAsDeliveredModalShowFromAggregateReport: function () {
        this.markAsDeliveredModalShow(true);
    },

    refreshModel: function (data) {
        var that = this;
        var model = new DocumentModel({id: data.model.get('id')});
        model.fetch({
            success: function () {
                var oldModel = that.collection.findWhere({id: model.get('id')});
                var oldModelIndex = that.collection.indexOf(data.model);
                var oldModelSelected = oldModel.get("selected");
                model.set("selected", oldModelSelected);
                that.collection.remove([oldModel]);
                that.collection.add(model, {at: oldModelIndex});

                if ((model.get('object').downloadedOrPreviewedSigners || []).filter(function (signer) {
                        return signer == that.getOption('username');
                    }).length > 0) {
                    that.notPreviewedDocumentsIds = (that.notPreviewedDocumentsIds || []).filter(function (item) {
                        return item !== model.get('id')
                    });
                    if (_.isEmpty(that.notPreviewedDocumentsIds)) {
                        that.showDocumentNotPreviewedMessage('hide');
                    }
                }

                if (that.documentsIds.length - that.notPreviewedDocumentsIds.length == 0 || that.notPreviewedDocumentsIds.length > 0) {
                    that.disableSignButtons();
                    //that.signDocsCallbackForPager.signDocuments = null;
                } else {
                    that.enableSignButtons();
                    /*that.signDocsCallbackForPager.signDocuments = function (fn) {
                        return that.signDocumentsBeforePageChanged(fn, that);
                    };*/
                }

                if (that.documentsIds.length == 0) {
                    that.signDocsCallbackForPager.signDocuments = null;
                } else {
                    that.signDocsCallbackForPager.signDocuments = function (fn) {
                        return that.signDocumentsBeforePageChanged(fn, that);
                    };
                }

                /*that.documentsIds = (that.documentsIds || []).filter(function (item) {
                    return item !== model.get('id')
                });*/
            }
        });
    },

    isPatientFilter: function (item) {
        return item.object && item.object.isPatient;
    },

    isMdFilter: function (item) {
        return item.object && item.object.isMd;
    },

    showPatientsSelect: function (defaultSelected) {
        var that = this;

        that.showChildView('patientsSelect', new RemoteSuggesterView({
            multiSelect: true,
            inputId: that.constants.documentPatient,
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(that.isPatientFilter).filter(function (item) {
                    return item.object && item.object.isPatient && item.object.mergeable === false;
                });
            },
            getIdFn: function (element) {
                return element.id;
            },
            getValueFn: function (element) {
                return element.name ? element.name.toUpperCase() : element.name;
            },
            classes: ["form-control"],
            placeholder: "Patient",
            defaultSelected: defaultSelected
        }));
    },

    showCreatedBySelect: function (defaultSelected) {
        var that = this;

        that.showChildView('createdBySelect', new RemoteSuggesterView({
            multiSelect: true,
            inputId: that.constants.createdBy,
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=organization',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getIdFn: function (element) {
                return element.id;
            },
            getValueFn: function (element) {
                return element.name ? element.name.toUpperCase() : element.name;
            },
            classes: ["form-control"],
            placeholder: "Requesting Organization",
            defaultSelected: defaultSelected
        }));
    },

    showAssignedToPersonsSelect: function (defaultSelected) {
        var that = this;

        that.showChildView('assignedToPersonsSelect', new RemoteSuggesterView({
            multiSelect: true,
            inputId: that.constants.personReviewRequest,
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=person',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(that.isMdFilter);
            },
            getIdFn: function (element) {
                return element.id;
            },
            getValueFn: function (element) {
                return element.name ? element.name.toUpperCase() : element.name;
            },
            classes: ["form-control"],
            placeholder: "Assigned Reviewer",
            defaultSelected: defaultSelected
        }));
    },

    showAssignedToOrganizationsSelect: function (defaultSelected) {
        var that = this;

        that.showChildView('assignedToOrganizationsSelect', new RemoteSuggesterView({
            multiSelect: true,
            inputId: that.constants.organizationReviewRequest,
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=organization',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getIdFn: function (element) {
                return element.id;
            },
            getValueFn: function (element) {
                return element.name ? element.name.toUpperCase() : element.name;
            },
            classes: ["form-control"],
            placeholder: "Assigned Organization",
            defaultSelected: defaultSelected
        }));
    },

    showSignedByPersonsSelect: function (defaultSelected) {
        var that = this;

        that.showChildView('signedByPersonsSelect', new RemoteSuggesterView({
            multiSelect: true,
            inputId: that.constants.personReviewFinishedRequest,
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=person',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(that.isMdFilter);
            },
            getIdFn: function (element) {
                return element.id;
            },
            getValueFn: function (element) {
                return element.name ? element.name.toUpperCase() : element.name;
            },
            classes: ["form-control"],
            placeholder: "Signed by Reviewer",
            defaultSelected: defaultSelected
        }));
    },

    showUploaderPersonsSelect: function (defaultSelected) {
        var that = this;

        that.showChildView('uploaderPersonsSelect', new RemoteSuggesterView({
            multiSelect: true,
            inputId: that.constants.documentUploaderPerson,
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=person',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getIdFn: function (element) {
                return element.id;
            },
            getValueFn: function (element) {
                return element.name ? element.name.toUpperCase() : element.name;
            },
            classes: ["form-control"],
            placeholder: "Uploader Person",
            defaultSelected: defaultSelected
        }));
    },

    showSignedByOrganizationsSelect: function (defaultSelected) {
        var that = this;

        that.showChildView('signedByOrganizationsSelect', new RemoteSuggesterView({
            multiSelect: true,
            inputId: that.constants.organizationReviewFinishedRequest,
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=organization',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getIdFn: function (element) {
                return element.id;
            },
            getValueFn: function (element) {
                return element.name ? element.name.toUpperCase() : element.name;
            },
            classes: ["form-control"],
            placeholder: "Signed by Organization",
            defaultSelected: defaultSelected
        }));
    },

    findSelectedIdBySelectedIndex: function (arr, index) {
        return ((arr || [])[index] || {}).id;
    },

    findSelectedIdBySelectedValue: function (arr, value) {
        var found = _.findWhere(arr, {name: value});
        return found ? found.id : null;
    },

    onShowDocumentsStatistics: function () {
        var that = this;
        that.ui.documentsStatisticsModal.modal({backdrop: 'static', keyboard: false});
        utils.showSpinner('#data-loader');

        var callback = function () {
            utils.hideSpinner('#data-loader');
        };

        that.initFilterParams();
        delete (that.params["page"]);
        delete (that.params["page-size"]);

        $.when(
            $.ajax({
                type: "GET",
                url: '/api/statistics/realtime/signers/documents/filtered?' + utils.objectToQueryParams(that.params)
            })
        ).then(
            function (response) {
                that.renderDocumentsStatisticsView(response, that.params);
                callback();
                $('.sending-method').tooltip();
            },
            function (error, text, status) {
                callback();

                if (error.status == 401) {
                    that.ui.documentsStatisticsModal.modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    actionsChannel.request("redirect:to:login");
                } else if (error.status == 403) {
                    notificationsChannel.request('show:notification',
                        error.responseJSON.message);
                } else {
                    notificationsChannel.request('show:notification',
                        'Error. Try later');
                }
            }
        );
    },

    onStaticticsAggregate: function (aggregateParams) {
        this.showDocumentsStatisticsAggregate(aggregateParams);
    },

    onShowDocumentsStatisticsAggregate: function () {
        var params = $.deparam(window.location.hash.replace('#documents', '').replace('?', ''));
        var aggregateParams = {};
        _.each(params, function (val, key) {
            if (key == 'aggregates' || key == 'contactTypes' || key == 'contactValue' || key == 'mdNameFrom' || key == 'mdNameTo' || key == 'orgNameFrom' || key == 'orgNameTo') {
                aggregateParams[key] = val;
            }
        });
        this.showDocumentsStatisticsAggregate(aggregateParams);
    },

    showDocumentsStatisticsAggregate: function (aggregateParams) {
        var that = this;
        that.ui.documentsStatisticsAggregateModal.modal({backdrop: 'static', keyboard: false});
        utils.showSpinner('#data-loader-aggregate');

        var callback = function () {
            utils.hideSpinner('#data-loader-aggregate');
        };

        that.initFilterParams();
        delete (this.params["page"]);
        delete (this.params["page-size"]);

        var extraParams = {};
        _.each(this.params, function (val, key) {
            if (key != 'aggregates' && key != 'contactTypes' && key != 'contactValue'
                && key != 'mdNameFrom' && key != 'mdNameTo' && key != 'orgNameFrom' && key != 'orgNameTo') {
                extraParams[key] = val;
            }
        });

        $.when(
            $.ajax({
                type: "GET",
                url: '/api/statistics/realtime/signers/documents/filtered/aggregated?' + utils.objectToQueryParams(_.extend(utils.deepClone(extraParams), aggregateParams))
            })
        ).then(
            function (response) {
                that.renderDocumentsStatisticsAggregateView(response, aggregateParams, extraParams || {});
                callback();
                $('.sending-method').tooltip();
            },
            function (error, text, status) {
                callback();
                if (error.status == 401) {
                    that.ui.documentsStatisticsAggregateModal.modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    actionsChannel.request("redirect:to:login");
                } else if (error.status == 403) {
                    notificationsChannel.request('show:notification',
                        error.responseJSON.message);
                } else {
                    notificationsChannel.request('show:notification',
                        'Error. Try later');
                }
            }
        );
    },

    renderDocumentsStatisticsView: function (data, params) {


        delete (params["ORGANIZATION_REVIEW_FINISHED_REQUEST"]);
        delete (params["ORGANIZATION_REVIEW_REQUEST"]);
        delete (params["ORGANIZATION_REVIEW_DELETED"]);
        delete (params["PERSON_REVIEW_FINISHED_REQUEST"]);
        delete (params["PERSON_REVIEW_REQUEST"]);
        delete (params["PERSON_REVIEW_DELETED"]);
        delete (params["object_status"]);

        this.showChildView('documentsStatisticsRegion', new DocumentsStatisticsView({
            data: data,
            extraParamsAsString: utils.objectToQueryParams(params)
        }));

    },

    renderDocumentsStatisticsAggregateView: function (data, aggregateParams, params) {

        var that = this;

        that.showChildView('documentsStatisticsAggregateRegion', new DocumentsStatisticsAggregateView({
            data: data,
            aggregateParams: aggregateParams,
            extraParams: params,
            getSelectedDocuments: function () {
                return that.documentsIds;
            }
        }));

        this.checkOrUncheckAllDocumentsInner(false);
    },

    onDocumentsSelectedInAggregateReport: function (docIds) {
        var that = this;
        docIds.forEach(function (docId) {
            that.documentsIds.push(docId);
        })
        that.documentsIds = _.uniq(that.documentsIds);
        console.log("onDocumentsSelectedInAggregateReport");
        console.log(that.documentsIds);
    },

    onDocumentsUnselectedInAggregateReport: function (docIds) {
        var that = this;
        that.documentsIds = (that.documentsIds || []).filter(function (id) {
            var found = _.find(docIds, function (docId) {
                return docId == id;
            });
            return !found;
        });
        that.documentsIds = _.uniq(that.documentsIds);
        console.log("onDocumentsUnselectedInAggregateReport");
        console.log(that.documentsIds);
    },

    onSetAsInitialViewSortingReportForMe: function () {
        this.getChildView('documentsStatisticsAggregateRegion').setAsInitialView();
    },

    onSetAsInitialViewSortingReport: function () {
        console.log("onSetAsInitialViewSortingReport");
        var url = this.getChildView('documentsStatisticsAggregateRegion').getUrlAsInitialView();
        console.log(url);

        this.setInitialViewModalView = new SetInitialViewModalView();
        this.showChildView('setInitialViewModal', this.setInitialViewModalView);
        this.setInitialViewModalView.show(url);
    },

    onSort: function (event) {
        this.params["sortby"] = event.target.id;
        if ($(event.target).children('div').hasClass('glyphicon-triangle-bottom')) {
            this.params["sortdir"] = "ASC";
        } else {
            this.params["sortdir"] = "DESC";
        }

        this.params.page = 0;
        window.location.hash = utils.getCleanBaseHash() + "?" + utils.objectToQueryParams(this.params);
    },

    signDocumentsBeforePageChanged: function (fn, that) {

        that.ui.signBeforeLeaveConfirmationSignButton.on('click', function (event) {
            that.ui.signBeforeLeaveConfirmationModal.modal('hide');
            that.signDocuments(fn, fn);
            that.signDocsCallbackForPager.signDocuments = null;
        });

        that.ui.signBeforeLeaveConfirmationCancelButton.on('click', function (event) {
            that.ui.signBeforeLeaveConfirmationModal.modal('hide');
            fn();
        });

        that.ui.signBeforeLeaveConfirmationCloseButton.on('click', function (event) {
            that.ui.signBeforeLeaveConfirmationModal.modal('hide');
        });
        that.ui.signBeforeLeaveConfirmationSignButton.hide();

        that.ui.signBeforeLeaveConfirmationModal.modal({backdrop: 'static', keyboard: false});
    }
});

module.exports = DocumentsListView;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/documents-list-view.js
// module id = 301
// module chunks = 0